// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608311104/js/" + chunkId + "." + {"44":"efab533a","225":"50b7fe15","481":"6c338514","486":"afdaede8","770":"ae824c8a"}[chunkId] + ".0.29327356078224065.chunk.js";
};